/// <amd-module name="Dashboards/WidgetCatalogUI/Utilities" />
import { DashboardWidgetProps } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import { WidgetCatalogProps } from "Dashboards/WidgetContracts/Internal/WidgetCatalogProps";

export namespace CatalogViewUtilities {
    /**
     *
     * Hands off drag from widget catalog item to catalog view, allowing catalog view to draw its own draggable element
     *
     * The initial position of draggable is not adjusted to where mouse actually is - it is moved there in componentDidUpdate
     */
    export function handOffDrag(e: MouseEvent, draggableElement: HTMLElement, catalogRowElement: HTMLElement): void {
        // Calculate event offsets, so that click is sent to the same relative point inside catalogview draggable element
        if (!catalogRowElement) {
            return;
        }
        const originalElementBounds = catalogRowElement.getBoundingClientRect();
        const xOffset = originalElementBounds.left - e.clientX;
        const yOffset = originalElementBounds.top - e.clientY;

        // Update UI in real time so we can read the bounding rectangle
        draggableElement.style.display = "block";
        const boundingRect = draggableElement.getBoundingClientRect();

        // Set up basic event fields
        const eventParams = {
            button: e.button,
            bubbles: true // Causes event to correctly propagate
        } as any;

        if (e.type === "dragstart") {
            // Create and dispatch adjusted MouseEvent which points at the draggable
            eventParams.clientX = boundingRect.left - xOffset;
            eventParams.clientY = boundingRect.top - yOffset;
            const new_event = new MouseEvent("mousedown", eventParams);

            draggableElement.dispatchEvent(new_event);
        }
    }

    /**
     * Draggable event handler, which checks if we can drop widget and passes the dropped widget payload to the dashboard
     * react-draggable library stops the drag when this returns false
     * On traversing the boundary (which is checked via isValidDropPoint callback), we stop catalog draggable by returning false -
     * and we pass the widget with event to grid by caling onDrop callback
     */
    export function handleDrag(e: MouseEvent, configSettings: DashboardWidgetProps, props: WidgetCatalogProps): false | void {
        if (e.type !== "mousemove") {
            return false;
        }

        // Calculate mouse position
        const x = e.clientX;
        const y = e.clientY;

        if (props.isValidDropPoint(x, y)) {
            props.onDrop(configSettings, e);

            // Returning false stops Draggable from more movement and returns it to initial position
            return false;
        }
    }

    /**
     * Called from componentDidUpdate to pass event to the draggable element
     * Moves the catalogview draggable element to where the widgetlist item is, so it looks like we are continuing the drag
     */
    export function finishHandOffDrag(handOffDragEvent: MouseEvent, draggableElement: Element): void {
        // Move the draggable back to where mouse was
        // We are passing all original parameters - some will be null depending on event type
        const eventParams = {
            button: handOffDragEvent.button,
            // Pass coordinates
            clientX: handOffDragEvent.clientX,
            clientY: handOffDragEvent.clientY
        } as any;

        // Dispatch mouse move event to our draggable to move it into actual mouse position

        if (handOffDragEvent.type == "dragstart") {
            const new_event = new MouseEvent("mousemove", eventParams);
            draggableElement.ownerDocument!.dispatchEvent(new_event);
        }
    }
}
